import { translate } from "../utils/locale";

export const NO_MLS = `My ${translate(
  "mls.label",
  "MLS"
)} isn’t on the list 🤔`;

export const IS_PROD = process.env.RAILS_ENV === "production";
export const IS_TEST = process.env.NODE_ENV === "test";
